import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import ProfileBlock from "./ProfileBlock";
import { adminApi, errorMessage } from "../../lib/api";
import { toast } from "sonner";

// Reusable read-only account profile dialog. Pass a userId to open; onClose clears it.
// Used from Live orders, Past orders and Payouts so admins can click a name → see the profile.
export default function AdminUserDialog({ userId, onClose }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) { setDetail(null); return; }
    let alive = true;
    setLoading(true);
    adminApi.userDetail(userId)
      .then((d) => { if (alive) setDetail(d.user); })
      .catch((e) => { if (alive) { toast.error(errorMessage(e)); onClose?.(); } })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={!!userId} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="max-w-lg" data-testid="admin-user-dialog">
        <DialogHeader>
          <DialogTitle>Account profile</DialogTitle>
          <DialogDescription>Full account details for this person.</DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
        ) : detail ? (
          <ProfileBlock profile={detail} />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
